import React, { useState } from 'react';
import { MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { company } from '../data/company';
const links = [{
  href: '#prestations',
  label: 'Prestations'
}, {
  href: '#tarifs',
  label: 'Tarifs'
}, {
  href: '#zones',
  label: 'Zones'
}, {
  href: '#artisan',
  label: "L'artisan"
}, {
  href: '#questions',
  label: 'Questions'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-40 border-b border-ink-800 bg-ink-950/95 backdrop-blur" data-id="element-115" data-mp="2rlmbf8mkvyfr">
      <div className="mx-auto flex max-w-content items-center gap-6 px-5 py-3 lg:px-8" data-id="element-116" data-mp="2wjnu3sg3dvqp">
        <a href="#top" className="flex items-baseline gap-2 text-bone" data-id="element-117" data-mp="31d9x0swgel9b">
          <span className="font-display text-lg font-extrabold uppercase tracking-tight" data-id="element-118" data-mp="36bl5az73onpf">
            Diawara
          </span>
          <span className="hidden text-xs font-medium uppercase tracking-[0.18em] text-brass-light sm:inline" data-id="element-119" data-mp="3bbfwz4yp9hbj">
            Serrurier
          </span>
        </a>

        <nav aria-label="Navigation principale" className="ml-auto hidden lg:block" data-id="element-120" data-mp="2wkkyrd1czo3r">
          <ul className="flex items-center gap-7" data-id="element-121" data-mp="2rlrgz8f1haxs">
            {links.map(link => <li key={link.href} data-id="element-122" data-mp="2ro4a8hq8z7q5">
                <a href={link.href} className="text-sm font-medium text-ink-500 transition-colors duration-150 ease-out hover:text-bone" data-id="element-123" data-mp="2mm5798yf6ctq">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <a href={company.phoneHref} className="ml-auto hidden items-center gap-2 rounded-sm bg-brass px-4 py-2.5 font-display text-sm font-bold text-ink-950 transition-colors duration-150 ease-out hover:bg-brass-light sm:flex lg:ml-0" data-id="element-124" data-mp="3abzffd7snd7n">
          <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-125" data-mp="30klj1eb52tiq" />
          {company.phone}
        </a>

        <button type="button" onClick={() => setOpen(v => !v)} className="ml-auto rounded-sm border border-ink-700 p-2 text-bone lg:hidden" aria-expanded={open} aria-controls="menu-mobile" aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'} data-id="element-126" data-mp="3tb3nainln0xq">
          {open ? <XIcon className="h-5 w-5" data-id="element-127" data-mp="1ho9xd27kgrfb" /> : <MenuIcon className="h-5 w-5" data-id="element-128" data-mp="1hmypaq738xie" />}
        </button>
      </div>

      {open && <nav id="menu-mobile" aria-label="Navigation mobile" className="border-t border-ink-800 lg:hidden" data-id="element-129" data-mp="1mlju72xac5d6">
          <ul className="mx-auto max-w-content px-5 py-2" data-id="element-130" data-mp="18pg0daqbpz18">
            {links.map(link => <li key={link.href} className="border-b border-ink-800 last:border-0" data-id="element-131" data-mp="1cmc7vq8kp0dx">
                <a href={link.href} onClick={() => setOpen(false)} className="block py-3 text-sm font-medium text-bone" data-id="element-132" data-mp="yr0d5iuf39x0">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>}
    </header>;
}